import { phoneDigitsForApi } from './phoneInputMask';

/** Same pattern as consumer `/sign-up` and provider enrollment account step. */
export const SIGNUP_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * @param {unknown} email
 * @param {{ requiredLabel?: string }} [options]
 * @returns {string} Empty string if valid, otherwise an error message.
 */
export function getSignupEmailError(email, options = {}) {
  const { requiredLabel = 'Email is required' } = options;
  const v = email != null ? String(email).trim() : '';
  if (!v) return requiredLabel;
  if (!SIGNUP_EMAIL_REGEX.test(v)) {
    return 'Please enter a valid email address';
  }
  return '';
}

/**
 * US numbers only: exactly 10 digits after stripping formatting.
 *
 * @param {unknown} phoneDisplay
 * @param {{ requiredLabel?: string }} [options]
 * @returns {string} Empty string if valid, otherwise an error message.
 */
export function getSignupPhoneError(phoneDisplay, options = {}) {
  const { requiredLabel = 'Phone number is required' } = options;
  const v = phoneDisplay != null ? String(phoneDisplay).trim() : '';
  if (!v) return requiredLabel;
  const digits = phoneDigitsForApi(phoneDisplay);
  if (!digits || digits.length !== 10) {
    return 'Please enter a 10-digit phone number';
  }
  return '';
}
